class History {
  constructor(container=null, isMobile = false) {
    if (container === null) {
      console.warn("History container was not found!");
      return;
    }
    this.container = container;
    this.isMobile = isMobile;
    this.init();
  }
  init() {
    this.productPagesContainer = this.container.querySelector(
      ".history__entries"
    );
    if (this.productPagesContainer === null) return;
    this.ordersContainer = this.container.querySelector(".history__orders");
    if (this.ordersContainer === null) return;
    this.orders = [
      ...this.container.querySelectorAll(".history__orders .order")
    ];
    if (this.orders.length < 1) return;
    this.productLists = [
      ...this.container.querySelectorAll(".history__entries .history__page")
    ];
    if (this.productLists.length < 1) return;
    // Event listeners
    this.orders.forEach((order, index) => {
      order.addEventListener("click", () => {
        this.show(index);
        if (this.isMobile) {
          this.productPagesContainer.classList.add("history__entries--active");
          this.ordersContainer.classList.add("history__orders--hidden");
        }
      });
    });
    this.show(0);
  }
  show(targetIndex) {
    const order = this.orders[targetIndex];
    const page = this.productLists.find(
      item => item.dataset.id === order.dataset.id
    );
    if (page) {
      this.productLists.forEach(current => {
        if (current === page) {
          current.classList.add("history__page--active");
        } else {
          current.classList.remove("history__page--active");
        }
      });
    }
    this.orders.forEach((order, index) => {
      if (index === targetIndex) {
        order.parentElement.classList.add("history__order--active");
      } else {
        order.parentElement.classList.remove("history__order--active");
      }
    });
  }
}

export default History;



// WEBPACK FOOTER //
// ./src/js/components/history.js